module.exports = __webpack_public_path__ + "img/no_documentation.ca9e8a05.svg";